import axios from "axios";
import { useEffect } from "react";
import { useAuthUser } from "react-auth-kit";
import { END_POINT } from "config/environment";

const SYNCED_KEY = "syncedTimezone";

/**
 * Reports the browser time zone so reminder emails (interviews, expiring
 * jobs) go out at the recruiter's local time. Sent once per browser session.
 */
export const useSyncTimezone = () => {
  const auth = useAuthUser();
  const authState = auth();
  const token: string | undefined = authState?.token;
  const isRecruiter = authState?.user?.type === "recruiter";

  useEffect(() => {
    if (!token || !isRecruiter) return;

    let timezone: string | undefined;
    try {
      timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (!timezone || sessionStorage.getItem(SYNCED_KEY) === timezone) return;
    } catch {
      return;
    }

    axios
      .put(
        `${END_POINT.BASE_URL}/v1/notification-preferences`,
        { timezone },
        {
          headers: {
            Accept: "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then(() => {
        try {
          sessionStorage.setItem(SYNCED_KEY, timezone as string);
        } catch {
          /* storage unavailable: retry next load */
        }
      })
      .catch(() => {
        /* non-blocking: the server falls back to its default time zone */
      });
  }, [token, isRecruiter]);
};
